import { useEffect, useState } from "react";
import { ChevronRight, Folder, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errorMessage } from "../../lib/api";

export const DriveFolderPicker = ({ open, onClose, onPick }) => {
  const [trail, setTrail] = useState([{ token: "root", name: "Mi unidad" }]);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const here = trail[trail.length - 1];

  useEffect(() => {
    if (!open) return;
    setData(null);
    setError("");
    api.get("/drive/folders", { params: { parent: here.token } }).then((r) => setData(r.data)).catch((e) => setError(errorMessage(e, "No se pudo leer tu Drive")));
  }, [open, here.token]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="drive-folder-picker">
        <DialogHeader>
          <DialogTitle>Cambiar carpeta</DialogTitle>
          <DialogDescription>Entra a la carpeta que tiene una subcarpeta por cliente y pulsa «Usar esta carpeta».</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap items-center gap-1 text-xs font-semibold text-[#5b667a]" data-testid="drive-picker-trail">
          {trail.map((t, i) => (
            <button key={t.token} type="button" onClick={() => setTrail(trail.slice(0, i + 1))} className="flex items-center gap-1 hover:text-[#0f5ef7]" data-testid={`drive-picker-trail-${i}`}>
              {i > 0 && <ChevronRight className="h-3 w-3" />}{t.name}
            </button>
          ))}
        </div>
        <div className="max-h-72 min-h-[8rem] overflow-y-auto rounded-xl border border-[#e8edf5]">
          {error && <p className="p-3 text-sm font-semibold text-[#b42318]" data-testid="drive-picker-error">{error}</p>}
          {!data && !error && <div className="flex justify-center p-6"><Loader2 className="h-5 w-5 animate-spin text-[#0f5ef7]" /></div>}
          {data?.folders.length === 0 && <p className="p-3 text-sm text-[#5b667a]">No hay subcarpetas aquí.</p>}
          {data?.folders.map((f, i) => (
            <button key={f.token} type="button" onClick={() => setTrail([...trail, f])} className="flex w-full items-center gap-2 border-b border-[#f0f3f8] px-3 py-2 text-left text-sm hover:bg-[#f5f8fd]" data-testid={`drive-picker-folder-${i}`}>
              <Folder className="h-4 w-4 text-[#0f5ef7]" /> {f.name}
            </button>
          ))}
        </div>
        <DialogFooter className="gap-2">
          <button type="button" onClick={onClose} className="tr-btn-light px-4 py-2 text-sm" data-testid="drive-picker-cancel">Cancelar</button>
          <button type="button" disabled={here.token === "root"} onClick={() => onPick({ token: here.token, name: here.name })} className="tr-btn-primary px-4 py-2 text-sm disabled:opacity-50" data-testid="drive-picker-use">
            Usar esta carpeta
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
